"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelDialogStyle_1 = require("./LabelDialogStyle");
const LabelsDialogContexts_1 = require("./LabelsDialogContexts");
const SearchBarWrapper = (0, vizportalclient_common_components_1.divWithStyle)('label-dialog-search', {
    padding: `24px 16px`,
    borderBottom: LabelDialogStyle_1.border,
});
const width = 900 - (2 * 16);
function SearchBar() {
    const dispatch = (0, LabelsDialogContexts_1.useLabelDialogControlsDispatcher)();
    const state = (0, LabelsDialogContexts_1.useLabelDialogControlsState)();
    return (react_1.default.createElement(SearchBarWrapper, null,
        react_1.default.createElement(widgets_1.TextFieldWidget, { tabIndex: 0, kind: 'search', label: null, style: { width }, onChange: e => dispatch({ type: 'SEARCH_VALUE', filter: e.target.value }), onClear: () => dispatch({ type: 'RESET_FILTER' }), placeholder: catalog_messages_1.Messages.LabelsDialog_SearchPlaceholder(), testId: 'label-dialog-search', value: state.kind === 'filter' ? state.filter : '' })));
}
exports.SearchBar = SearchBar;
//# sourceMappingURL=LabelSearchBar.js.map